module.exports = __webpack_public_path__ + "static/media/u.09392e8f.svg";